import { render, staticRenderFns } from "./WorkspaceSelection.vue?vue&type=template&id=873eb3e6&"
import script from "./WorkspaceSelection.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSelection.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSelection.vue?vue&type=style&index=0&id=873eb3e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports